import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  contactPhone: {
    defaultMessage: 'Phone Contact',
    description: 'Label for phone contact input',
    id: 'Cs9zgs',
  },
  contactName: {
    defaultMessage: 'Name Contact',
    description: 'Label for name contact input',
    id: 'wCCXsj',
  },
});
